export function setHeight() {
  let navH = 0;
  let navBarH = 0;
  const header = document.querySelector('.header');
  const nav = document.querySelector('.header-nav');
  const navbar = document.querySelector('.navbar');

  function setElementsHeight() {
    header.dataset.navActiveHeight = '';
    navH = nav.offsetHeight;
    navBarH = navbar.offsetHeight;
    header.dataset.navActiveHeight = navH + navBarH;
    nav.classList.add('is-height-set');
  }

  function handleResize() {
    nav.classList.remove('is-height-set');
    setElementsHeight();
  }

  setElementsHeight();
  
  let lastInnerWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (lastInnerWidth !== window.innerWidth) {
      lastInnerWidth = window.innerWidth;
      handleResize();
    }
  });
}